import axios from "axios"

export const getSearchSuggestionsApi = (query) => {
	const prodUrl = process.env.REACT_APP_BASE_URL
	return axios
		.get(prodUrl + `inventory-service/api/v1/search/suggest/?q=${encodeURIComponent(query)}`)
		.then(function (response) {
			return response
		})
		.catch((error) => {
			return error
		})
}

export const getSearchResultsApi = ({ query, brandId, categoryId, offset }) => {
	const prodUrl = process.env.REACT_APP_BASE_URL
	const params = new URLSearchParams()
	if (brandId) params.append("brand_id", brandId)
	if (categoryId) params.append("category_id", categoryId)
	if (offset) params.append("offset", offset)
	const queryString = params.toString() ? `?${params.toString()}` : ""

	return axios
		.get(prodUrl + `inventory-service/api/v1/search/product/${encodeURIComponent(query)}/${queryString}`)
		.then(function (response) {
			return response
		})
		.catch((error) => {
			return error
		})
}
